import { getTimeFormatFromLocale } from './helpers'

export class MobileBookingFlowManager {
  constructor({
    locale,
    datePickerController,
    durationInMinutesValue,
    showBookingForm,
    getSlots,
    onTimeZoneChange,
    toLuxonDateTime,
    toLuxonDateTimeKeepingSameTime,
    slotPickerElements,
  }) {
    this.locale = locale
    this.datePickerController = datePickerController
    this.durationInMinutesValue = durationInMinutesValue
    this.showBookingForm = showBookingForm
    this.getSlots = getSlots
    this.toLuxonDateTime = toLuxonDateTime
    this.toLuxonDateTimeKeepingSameTime = toLuxonDateTimeKeepingSameTime
    this.slotPickerElements = slotPickerElements

    // This is a template for an option of the time slot picker
    this.slotPickerOptionTemplate =
      this.slotPickerElements.buttonGroup.children[0]
    this.slotPickerOptionTemplate.classList.remove('hidden')
    this.slotPickerOptionTemplate.remove()
    this.slotPickerOptionTemplate =
      this.slotPickerOptionTemplate.outerHTML.replaceAll(
        'checked="checked"',
        ''
      )

    // When someone changes the timezone, let's update the slots shown on the slot picker
    onTimeZoneChange((tz) => {
      this.timeZone = tz
      this.updateSlotPicker()
    })

    // When someone selects a date on the date picker, let's show the time slots for that date
    this.attachDateChangeListener()

    // Attach a click listener for when someone clicks on a slot picker item
    this.attachSlotPickerItemSelectListener()
  }

  hideSlotPicker = () => {
    this.slotPickerElements.container.classList.add('hidden')
  }

  /***************
    Private stuff
  ***************/

  attachDateChangeListener() {
    this.datePickerController.onDateSelect((date) => {
      if (!date) return
      this.selectedDate = date
      this.showSlotPicker()
    })
  }

  attachSlotPickerItemSelectListener() {
    this.slotPickerElements.buttonGroup.addEventListener('change', (e) => {
      const start = this.toLuxonDateTime(new Date(e.target.value))
      const end = start.plus({ minutes: this.durationInMinutesValue })
      this.showBookingForm({ slot: { start, end }, type: 'normal' })
    })
  }

  showSlotPicker() {
    this.updateSlotPicker()
    this.slotPickerElements.container.classList.remove('hidden')
  }

  async updateSlotPicker() {
    const selectedDate = this.selectedDate
    if (!selectedDate) return
    let dateLuxon = this.toLuxonDateTimeKeepingSameTime(selectedDate)
    if (this.timeZone) {
      dateLuxon = dateLuxon.setZone(this.timeZone)
    }

    this.slotPickerElements.date.innerText =
      dateLuxon.toFormat('cccc, LLLL d, y')

    const startOfDay = dateLuxon.startOf('day')
    const endOfDay = dateLuxon.endOf('day')

    this.slotPickerElements.buttonGroup.innerHTML = ''
    const slots = await this.getSlots(startOfDay, endOfDay)
    slots.forEach((slot) => {
      const option = this.slotPickerOptionTemplate
        .replaceAll(
          '___LABEL___',
          slot.start.toFormat(getTimeFormatFromLocale(this.locale))
        )
        .replaceAll('___VALUE___', slot.start.toISO())
      this.slotPickerElements.buttonGroup.innerHTML += option
    })

    this.slotPickerElements.emptyState.classList.toggle(
      'hidden',
      !!slots.length
    )
  }
}
